export default "__VITE_ASSET__BXzqLhRW__"